import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { companyInfo, siteMeta } from "../data/companyData";

const pageMeta = {
  "/": {
    title: siteMeta.title,
    description: siteMeta.description,
  },
  "/home": {
    title: siteMeta.title,
    description: siteMeta.description,
  },
  "/about": {
    title: "About Us | Quinterra Software Solutions Pvt. Ltd.",
    description:
      "Learn about Quinterra — an AI SaaS product company building platforms for HR, education, CRM, and enterprise operations.",
  },
  "/products": {
    title: "Products | Quinterra Software Solutions Pvt. Ltd.",
    description:
      "Explore Quinterra's AI SaaS products including Hr-Assist, Qshikshak, LeadGen AI, and Land Intelligence.",
  },
  "/contact": {
    title: "Contact Us | Quinterra Software Solutions Pvt. Ltd.",
    description:
      "Get in touch with Quinterra Software Solutions. Email founder@quinterrasoft.com or call +91 6304748719.",
  },
  "/privacy-policy": {
    title: "Privacy Policy | Quinterra Software Solutions Pvt. Ltd.",
    description: "Privacy Policy for Quinterra Software Solutions Pvt. Ltd. SaaS products and services.",
  },
  "/terms-of-service": {
    title: "Terms of Service | Quinterra Software Solutions Pvt. Ltd.",
    description: "Terms of Service for Quinterra Software Solutions Pvt. Ltd. SaaS products and services.",
  },
  "/technologies": {
    title: "Technology Stack | Quinterra Software Solutions Pvt. Ltd.",
    description:
      "Quinterra's cloud-native technology stack: React, Node.js, Python, MongoDB, AWS, AI, and more.",
  },
};

function setMetaTag(attr, key, content) {
  let element = document.querySelector(`meta[${attr}="${key}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attr, key);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

function setCanonical(url) {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    document.head.appendChild(link);
  }
  link.setAttribute("href", url);
}

function setJsonLd(data) {
  let script = document.getElementById("quinterra-jsonld");
  if (!script) {
    script = document.createElement("script");
    script.id = "quinterra-jsonld";
    script.type = "application/ld+json";
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(data);
}

export default function SEO() {
  const location = useLocation();
  const meta = pageMeta[location.pathname] || pageMeta["/"];
  const pageUrl = `${siteMeta.url}${location.pathname === "/" ? "" : location.pathname}`;

  useEffect(() => {
    document.title = meta.title;

    setMetaTag("name", "description", meta.description);
    setMetaTag("property", "og:title", meta.title);
    setMetaTag("property", "og:description", meta.description);
    setMetaTag("property", "og:type", "website");
    setMetaTag("property", "og:url", pageUrl);
    setMetaTag("property", "og:site_name", companyInfo.legalName);
    setMetaTag("name", "twitter:card", "summary_large_image");
    setMetaTag("name", "twitter:title", meta.title);
    setMetaTag("name", "twitter:description", meta.description);
    setCanonical(pageUrl);

    setJsonLd({
      "@context": "https://schema.org",
      "@type": "Organization",
      name: companyInfo.legalName,
      url: siteMeta.url,
      logo: `${siteMeta.url}/favicon.png`,
      description: siteMeta.description,
      foundingDate: companyInfo.founded,
      address: {
        "@type": "PostalAddress",
        addressLocality: "Hyderabad",
        addressRegion: "Telangana",
        addressCountry: "IN",
      },
      contactPoint: {
        "@type": "ContactPoint",
        telephone: companyInfo.phone,
        email: companyInfo.email,
        contactType: "customer service",
      },
      sameAs: ["https://hr-assist.in", "https://qshikshak.com/", companyInfo.linkedin],
    });
  }, [meta.description, meta.title, pageUrl]);

  return null;
}
